<article appAnimateOnScroll class="card h-100 border-0 shadow-sm news-card">
  <div class="card-body">
    <div class="d-flex align-items-center mb-3">
      <i
        [class]="'fa-solid ' + icon + ' fa-2x text-primary me-3'"
        aria-hidden="true"
      ></i>
      <h3 class="h6 mb-0 fw-bold">{{ title }}</h3>
    </div>
    <p class="text-muted mb-2">
      <small>
        <i class="fa-regular fa-calendar me-1" aria-hidden="true"></i>
        {{ date }}
      </small>
    </p>
    <p class="mb-3 text-muted">{{ description }}</p>

    <!-- Link para a notícia (se houver URL válida) -->
    @if (hasValidUrl) {
      <a
        [href]="url"
        target="_blank"
        rel="noopener noreferrer"
        class="btn btn-sm btn-outline-primary"
        >
        <i class="fa-solid fa-external-link-alt me-1"></i>
        Ler mais
      </a>
    }
  </div>
</article>
